import { create } from 'zustand'

export type ModalOptionsProps = 'deposit' | 'withdraw'

type SearchModalStore = {
  open: boolean
  type: ModalOptionsProps
}

export const useTransitionModalStore = create<SearchModalStore>(() => ({
  open: false,
  type: 'deposit',
}))

// Selectors
const openSelector = (state: SearchModalStore): boolean => state.open
const typeSelector = (state: SearchModalStore): ModalOptionsProps => state.type

// Getters
const getOpen = (): boolean => openSelector(useTransitionModalStore.getState())
const getType = (): ModalOptionsProps =>
  typeSelector(useTransitionModalStore.getState())

// Hooks
export const useTransactionModal = () => useTransitionModalStore(openSelector)
export const useTypeTransactionModal = () =>
  useTransitionModalStore(typeSelector)

// ACTIONS (setStates)
export const onTransactionOpen = (): void => {
  useTransitionModalStore.setState({ open: true })
}

export const onTransactionTypedOpen = (type: ModalOptionsProps): void => {
  useTransitionModalStore.setState({ open: true, type })
}

export const onTransactionClose = (): void => {
  useTransitionModalStore.setState({ open: false })
}

export const onTransactionToggle = (): void => {
  useTransitionModalStore.setState((state) => ({ open: !state.open }))
}

export const setTransactionModalType = (type: ModalOptionsProps): void => {
  useTransitionModalStore.setState(() => ({ type }))
}
